export const Steps = {
  Selection: "Selection",
  Action: "Action",
  Confirmation: "Confirmation"
} as const;

export type Steps = (typeof Steps)[keyof typeof Steps];
